import * as types from '../mutations'
import BatchService from '@/services/BatchService'

const state = {
  selectedBatch: {},
  batches: [],
  count: 0,
  filteredBatches: [],
  loading: true
}

const getters = {
  selectedBatch: (state) => state.selectedBatch,
  batches: (state) => state.batches,
  batchCount: (state) => state.count,
  filteredBatches: (state) => state.filteredBatches,
  batchLoading: (state) => state.loading
}

const actions = {

  clearBatchSelection ({ commit }) {
    commit(types.CLEAR_BATCH_SELECTION)
  },

  selectBatch ({ commit }, { batch }) {
    commit(types.SELECT_BATCH, batch)
  },

  async searchBatch ({ commit }, search) {
    commit(types.BATCH_LOADING)
    let data = await BatchService.loadBatches(search)
    commit(types.SET_FILTERED_BATCH_LIST, data)
    commit(types.BATCH_LOADED)
  },

  async loadBatchList ({ commit }) {
    commit(types.BATCH_LOADING)
    let data = await BatchService.loadBatches()
    commit(types.SET_BATCH_LIST, data)
    commit(types.SET_FILTERED_BATCH_LIST, data)
    commit(types.BATCH_LOADED)
  },

  async checkBatchId ({ commit }, { id }) {
    try {
      let res = await BatchService.checkSlug(id)
      return Promise.resolve(res)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  async createBatch ({ commit }, { batch }) {
    try {
      let res = await BatchService.createBatch(batch)
      commit(types.BATCH_CREATED, res)
      return Promise.resolve(batch)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  async assignLotToBatch ({ commit }, { batchId, lot, csv }) {
    if (csv) {
      try {
        await BatchService.assignLot(batchId, lot)
        return Promise.resolve()
      } catch (err) {
        return Promise.reject(err)
      }
    } else {
      await BatchService.assignLot(batchId, lot.id)
      commit(types.LOT_ADDED_TO_BATCH, { batchId, lot })
    }
    return Promise.resolve()
  }

}

const mutations = {

  [types.SELECT_BATCH] (state, batch) {
    state.selectedBatch = batch
  },

  [types.CLEAR_BATCH_SELECTION] (state) {
    state.selectedBatch = {}
  },

  [types.SET_BATCH_LIST] (state, data) {
    state.batches = data.results
  },

  [types.SET_FILTERED_BATCH_LIST] (state, data) {
    state.filteredBatches = data.results
    state.count = data.count
  },

  [types.BATCH_LOADING] (state) {
    state.loading = true
  },

  [types.BATCH_LOADED] (state) {
    state.loading = false
  },

  [types.BATCH_CREATED] (state, batch) {
    state.batches.unshift(batch)
  },

  [types.LOT_ADDED_TO_BATCH] (state, { batchId, lot }) {
    let index = state.batches.findIndex((b) => {
      return b.id === batchId
    })

    if (~index) {
      state.batches[index].lots.push(lot)
    }
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
